import React, { useCallback, useState } from 'react';
import { Option } from '@minecraft.select';
import { captureExceptionEvent } from '@blocs.observability';

export interface GenericSortOptionsKey<T extends string> {
  // values are set according to their index, changing the values to a different pattern will break sort functionality
  value: null | T;
  label: string;
}

export function useSortOptions<T extends string>(options: GenericSortOptionsKey<T>[], defaultValue: null | T) {
  const [sortValue, setSortValue] = useState<null | T>(defaultValue);

  const sortOptionsLabels: Option[] = options.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  const handleMobileSortEvent = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      const { value } = e.target;
      const selectedOption = options.find((option) => option.value === value);

      if (!selectedOption) {
        captureExceptionEvent(new Error(`Invalid sort option value: ${value}`));
      } else {
        setSortValue(value as T);
      }
    },
    [options]
  );

  return {
    sortOptionsKey: options,
    sortOptionsLabels,
    sortValue,
    handleMobileSortEvent,
  };
}
